import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewTower = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.283 5.137 12 2 8.717 5.137l1.245.513.675.277L12 6.488l1.363-.56.675-.279 1.245-.512Zm1.974-.11-2.281.938L12 10.288 9.025 5.965l-2.282-.939L5 5.971l1.997 2.085L12 13.278l5.003-5.222L19 5.97l-1.743-.945Zm-10.12 4.34L12 14.443l4.864-5.076-1.511 10.323H8.648L7.136 9.367Zm1.15 11.051h7.427L17.495 22H6.505l1.781-1.582ZM10.26 6.474 12 7.19l1.738-.716.01.014L12 9.028l-1.748-2.54.009-.014Z"
      clipRule="evenodd"
    />
  </svg>
);
